import { render, staticRenderFns } from "./instructions-questions.vue?vue&type=template&id=a4ec2420&scoped=true&"
import script from "./instructions-questions.vue?vue&type=script&lang=js&"
export * from "./instructions-questions.vue?vue&type=script&lang=js&"
import style0 from "./instructions-questions.vue?vue&type=style&index=0&id=a4ec2420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec2420",
  null
  
)

export default component.exports